document.addEventListener('DOMContentLoaded', function () {
  var slides = document.querySelectorAll('.single-product-featured');
  if (slides.length < 2) return;

  var wrapper = document.createElement('div');
  wrapper.className = 'quick-order-carousel';
  slides[0].parentNode.insertBefore(wrapper, slides[0]);

  slides.forEach(function (slide, i) {
    wrapper.appendChild(slide);
    if (i > 0) slide.style.display = 'none';
  });

  var current = 0;

  var prevBtn = document.createElement('button');
  prevBtn.className = 'quick-order-carousel__nav quick-order-carousel__nav--prev';
  prevBtn.setAttribute('aria-label', 'Previous product');
  prevBtn.innerHTML = '<svg width="16" height="34" viewBox="0 0 16 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5918 8.57227L5.16406 18L14.5918 27.4277L11.999 30.0205L11.6455 29.667L1.27539 19.2959C0.931728 18.9521 0.738319 18.4861 0.738281 18C0.738281 17.5139 0.931718 17.0479 1.27539 16.7041L11.6455 6.33301L11.999 5.97949L14.5918 8.57227Z" fill="#231F20" stroke="#231F20"/><path d="M14.5918 6.57227L5.16406 16L14.5918 25.4277L11.999 28.0205L11.6455 27.667L1.27539 17.2959C0.931728 16.9521 0.738319 16.4861 0.738281 16C0.738281 15.5139 0.931718 15.0479 1.27539 14.7041L11.6455 4.33301L11.999 3.97949L14.5918 6.57227Z" fill="white" stroke="white"/></svg>';

  var nextBtn = document.createElement('button');
  nextBtn.className = 'quick-order-carousel__nav quick-order-carousel__nav--next';
  nextBtn.setAttribute('aria-label', 'Next product');
  nextBtn.innerHTML = '<svg width="16" height="34" viewBox="0 0 16 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.4082 8.57227L10.8359 18L1.4082 27.4277L4.00098 30.0205L4.35449 29.667L14.7246 19.2959C15.0683 18.9521 15.2617 18.4861 15.2617 18C15.2617 17.5139 15.0683 17.0479 14.7246 16.7041L4.35449 6.33301L4.00098 5.97949L1.4082 8.57227Z" fill="#231F20" stroke="#231F20"/><path d="M1.4082 6.57227L10.8359 16L1.4082 25.4277L4.00098 28.0205L4.35449 27.667L14.7246 17.2959C15.0683 16.9521 15.2617 16.4861 15.2617 16C15.2617 15.5139 15.0683 15.0479 14.7246 14.7041L4.35449 4.33301L4.00098 3.97949L1.4082 6.57227Z" fill="white" stroke="white"/></svg>';

  wrapper.appendChild(prevBtn);
  wrapper.appendChild(nextBtn);

  function showSlide(index) {
    slides[current].style.display = 'none';
    current = (index + slides.length) % slides.length;
    slides[current].style.display = '';
  }

  prevBtn.addEventListener('click', function () { showSlide(current - 1); });
  nextBtn.addEventListener('click', function () { showSlide(current + 1); });
});

/* ---------------------------------------------------------------------------
   Cart drawer "You might also like" (snippets/cart-cross-sell.liquid).
   These used to be inline <script>s in the cross-sell markup, which only ran when the
   cart already had items at page load — the drawer re-renders its HTML without running
   scripts, so after a first add-to-cart the arrows and one-tap upgrade buttons did nothing.
   --------------------------------------------------------------------------- */
    (function () {
      if (window.__cartXsellSwipeInit) return;
      window.__cartXsellSwipeInit = true;

      function step(track) {
        var c = track.querySelectorAll('.shoppable-product-card');
        return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : 0;
      }

      /* Move the track by one card; dir = 1 (next) or -1 (prev). Clamped to bounds. */
      window.cartXsellSlide = function (track, dir) {
        if (!track) return;
        var n = track.querySelectorAll('.shoppable-product-card').length;
        var i = Math.min(Math.max((+track.dataset.i || 0) + dir, 0), n - 1);
        track.dataset.i = i;
        track.style.transform = 'translateX(' + (-i * step(track)) + 'px)';
      };

      /* Touch swipe — delegated on document so it survives cart-drawer re-renders. */
      var track = null, startX = 0, startY = 0, horizontal = false;
      document.addEventListener('touchstart', function (e) {
        track = e.target.closest ? e.target.closest('.wt-cart__cross-sell__track') : null;
        if (!track) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        horizontal = false;
      }, { passive: true });
      document.addEventListener('touchmove', function (e) {
        if (!track) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (!horizontal && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) horizontal = true;
      }, { passive: true });
      document.addEventListener('touchend', function (e) {
        if (!track) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (horizontal && Math.abs(dx) > 40) window.cartXsellSlide(track, dx < 0 ? 1 : -1);
        track = null;
      }, { passive: true });
    })();

  (function () {
    if (window.__sbUpgradeInit) return;
    window.__sbUpgradeInit = true;

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    // Take one of each replaced variant out of the cart (comma-separated ids, e.g. two refills
    // swapped for the Paper Sampler Set).
    function dropBase(variantIds) {
      var ids = String(variantIds).split(',').filter(Boolean);
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var updates = {};
        ids.forEach(function (id) {
          var line = cart.items.find(function (i) { return String(i.variant_id) === String(id); });
          if (line) updates[id] = line.quantity - 1;
        });
        if (!Object.keys(updates).length) return;
        return post('/cart/update.js', { updates: updates });
      });
    }

    function refreshDrawer() {
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
    }

    // Single-variant sets (Duo): swap in place from the cart drawer.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-sb-upgrade-swap]');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'Updating...';
      post('/cart/add.js', { items: [{ id: Number(btn.dataset.bundleVariant), quantity: 1 }] })
        .then(function (res) {
          if (res.status) throw res;
          return dropBase(btn.dataset.baseVariant);
        })
        .then(refreshDrawer)
        .catch(function () { btn.textContent = label; btn.disabled = false; });
    });

    // Picker sets: on the set PDP opened with ?upgrade=<variant>, swap after Add to cart.
    var base = new URLSearchParams(window.location.search).get('upgrade');
    if (!base) return;
    document.addEventListener('DOMContentLoaded', function () {
      var submit = document.querySelector('product-form .product-form__submit');
      if (submit) {
        var note = document.createElement('p');
        note.className = 'sb-upgrade-note';
        note.textContent = 'Upgrading: we\'ll swap the Stickerbox in your cart for this set.';
        submit.insertAdjacentElement('beforebegin', note);
      }
      if (typeof subscribe !== 'function') return;
      var done = false;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (done || !event || event.source !== 'product-form') return;
        done = true;
        history.replaceState(null, '', window.location.pathname);
        if (note) note.remove();
        dropBase(base).then(refreshDrawer);
      });
    });
  })();
